import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import { CaretDownIcon, RemoveIcon } from "@/v1/components/atoms/Icons";

import { useRequestsStore } from "../../../store/useRequestsStore/useRequestsStore";

import { Asset } from "./components/Asset/Asset";
import { RequestsInfo } from "./components/RequestsInfo/RequestsInfo";

import "./requestsManager.scss";

export const RequestsManager = () => {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const { removeAllRequests, activeRequests } = useRequestsStore(
    (state) => state,
    (a, b) => a.activeRequests === b.activeRequests,
  );

  useEffect(() => {
    setOpen(activeRequests.length !== 0);
  }, [activeRequests.length]);

  if (!open) return null;

  return (
    <section className={`request-manager ${collapsed ? "collapsed" : ""}`}>
      <div className="request-manager__header">
        <span>
          <FormattedMessage id="label.assets-manager" />
        </span>
        <div className="request-manager__actions">
          <span className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
            <CaretDownIcon />
          </span>
          <span className="reset-btn" onClick={() => removeAllRequests()}>
            <RemoveIcon />
          </span>
        </div>
      </div>
      <div className="request-manager__content">
        {activeRequests
          .filter((asset) => !asset.folderName)
          .map((asset) => (
            <Asset key={asset.id} {...asset} />
          ))}
      </div>
      <RequestsInfo />
    </section>
  );
};
